import React from 'react';

const ForceUpdateGate = React.Fragment;

export { ForceUpdateGate };
